import styled from "styled-components"

import {Label} from "../../Typography"
import Dot from "../Dot"

interface Props {
  margin?: string
  center?: boolean
  backgroundColor?: string
  isWhiteText?: boolean
  inline?: boolean
  fontSize?: string
  lineHeight?: string
  padding?: string
}

export const Container = styled(Label)<Props>`
  display: ${({inline}) => (inline ? "inline-flex" : "flex")};
  align-items: center;
  ${({center}) => center && "text-align: center;"};
  background-color: ${({backgroundColor, theme}) => backgroundColor || theme.colors.greys.light};
  color: ${({isWhiteText, theme}) => (isWhiteText ? theme.colors.greys.white : theme.colors.greys.black)};
  padding: ${({padding}) => padding || "5px 10px"};
  border-radius: ${({theme}) => theme.border.radius.medium};
  ${({margin}) => margin && `margin: ${margin};`}
  white-space: nowrap;
  font-size: ${({fontSize}) => (fontSize ? fontSize : "10px")};
  line-height: ${({lineHeight}) => (lineHeight ? lineHeight : "12px")};
`

export const StyledDot = styled(Dot)`
  margin-left: 7px;
`
